import p1 from '../static/p1.png'
import p2 from '../static/p2.png'
import p3 from '../static/p3.png'
import p4 from '../static/p4.png'
import p5 from '../static/p5.png'
import p6 from '../static/p6.png'
import p7 from '../static/p7.png'


export default [p1, p2, p3, p4, p5, p6, p7]